module.exports = __webpack_public_path__ + "static/media/remove.0cbc0099.svg";